
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 100 100","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.747 16C9.707 16 4 21.707 4 28.747v2.451l43.329 19.248a8.923 8.923 0 007.316-.033L96.873 31.21v-2.462c0-7.04-5.707-12.747-12.747-12.747H16.747zm80.126 21.744L57.108 55.828a14.872 14.872 0 01-12.194.054L4 37.708v34.38c0 7.04 5.707 12.747 12.747 12.747h67.379c7.04 0 12.747-5.707 12.747-12.747V37.744z","fill":"#E5B409"}})])
          )
        }
      }
    